"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyMap = exports.currencyRevMap = exports.SfilterCurrency = void 0;
var SfilterCurrency;
(function (SfilterCurrency) {
    SfilterCurrency[SfilterCurrency["USD"] = 1] = "USD";
    SfilterCurrency[SfilterCurrency["EUR"] = 2] = "EUR";
    SfilterCurrency[SfilterCurrency["HKD"] = 3] = "HKD";
    SfilterCurrency[SfilterCurrency["RMB"] = 4] = "RMB";
    SfilterCurrency[SfilterCurrency["GBP"] = 5] = "GBP";
})(SfilterCurrency = exports.SfilterCurrency || (exports.SfilterCurrency = {}));
exports.currencyRevMap = {
    gbp: 5,
    rmb: 4,
    hkd: 3,
    eur: 2,
    usd: 1,
};
exports.currencyMap = {
    5: 'gbp',
    4: 'rmb',
    3: 'hkd',
    2: 'eur',
    1: 'usd',
};
